import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AccountSettings} from '../../data/AccountSettings';
import {AccountSettingsService} from '../../services/account-settings.service';
import packageInfo from "../../../../../package.json";
import buildFile from "../../../../../buildNumber.json";
import {PlatformService} from "../../../app-common/services/native/platform.service";
import {NativeService} from "../../../app-common/services/native/native.service";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-account-settings-modal',
  templateUrl: './account-settings-modal.component.html',
  styleUrls: ['./account-settings-modal.component.scss']
})
export class AccountSettingsModalComponent implements OnInit {
  @Input() settingsPopupOpen: boolean;
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  settings: AccountSettings;
  frontEndVersion: string = packageInfo.version;
  frontEndBuildNumber: string = buildFile.buildNumber;
  desktopWrapperVersionAndBuildNumber: string = '';
  isDev = environment.production === false;


  availableLanguages: any[] = [
    {label: 'English', value: 'en'},
    {label: 'Spanish', value: 'es'},
  ];

  availableThemes: any[] = [
    {label: 'Light', value: 'light'},
    {label: 'Dark', value: 'dark'},
  ];

  constructor(private accountSettingsService: AccountSettingsService,
              public platformService: PlatformService,
              private nativeService: NativeService) { }

  async ngOnInit(): Promise<void> {
    this.settings = await this.accountSettingsService.getSettings();
    if (this.platformService.isElectronApp) {
      const promise = await this.nativeService.getVersion();
      const {version, buildNumber} = promise;
      this.desktopWrapperVersionAndBuildNumber = `v${version} (${buildNumber})`;
    }
  }

  async saveSettings(): Promise<void> {
    this.accountSettingsService.saveSettings(this.settings).then(x => this.closePopup());
  }

  async closePopup(): Promise<void> {
    this.settingsPopupOpen = false;
    this.onClose.emit();
    this.settings = await this.accountSettingsService.getSettings();
  }

}
